import produce from "immer"
import { MarkovStartvector } from "server/models"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

export const initMarkovStartvector: MarkovStartvector = {
    id: null,
    modelId: null,
    name: "",
    order: 0,
}

const initMarkovStartvectorState: types.MarkovStartvectorState = {
    startvectors: [],
    startvectorSelected: null,
    startvectorEdit: initMarkovStartvector,

    reloadList: true,
    reloadEdit: true,
}

const markovStartvectorReducer = produce((
    draft: types.MarkovStartvectorState = initMarkovStartvectorState,
    action: ActionTypes = null,
): types.MarkovStartvectorState => {
    switch (action.type) {
        case types.MARKOV_STARTVECTORS:
            draft.startvectors = action.startvectors
            return draft

        case types.MARKOV_STARTVECTOR_SELECTED:
            draft.startvectorSelected = action.startvector
            return draft

        case types.MARKOV_STARTVECTOR_EDIT:
            draft.startvectorEdit = action.startvector
            return draft

        case types.MARKOV_STARTVECTOR_RELOAD_LIST:
            draft.reloadList = action.value
            return draft

        case types.MARKOV_STARTVECTOR_RELOAD_EDIT:
            draft.reloadEdit = action.value
            return draft

        default:
            return draft
    }
})
export default markovStartvectorReducer
